<template>
  <div class="editor scroll-vertical">
    <detail-item
      name="Host Name"
      imgName="circle">
      {{ item.parsed.host.hostname }}
    </detail-item>
    <detail-item
      name="IP"
      imgName="circle">
      {{ item.parsed.host.ips.join(', ') }}
    </detail-item>
  </div>
</template>

<script>
import DetailItem from '@/components/DetailItem.vue';

export default {
  name: 'AlertLogHostDetails',
  components: {
    DetailItem,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
